export const DEFAULT_MEDIA_SIZE_SLUG = 'full';
//# sourceMappingURL=constants.js.map